import { memo } from 'react';
import { Card } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NO_DATA } from '../../constants/message.constants';

const AdherenceDataTable = ({
  isLoading,
  projectsData,
  totalRows,
  perPage,
  handlePageChange,
  handleLimitChange,
}) => {
  const permissions = useSelector((state) => state.permissionsReducer);
  const tableColumns = [
    {
      name: <div>TEAM MEMBER NAME</div>,
      selector: (row) => row.teamMemberName,
      sortable: true,
      cell: (row) => row.teamMemberName,
      filterable: true,
    },
    {
      name: <div>EMAIL</div>,
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => row.email,
      filterable: true,
      width: '200px',
    },
    {
      name: <div>EMPLOYEE ID</div>,
      selector: (row) => row.employeeId,
      sortable: true,
      cell: (row) => row.employeeId,
      filterable: true,
    },
    {
      name: <div>SITE NAME</div>,
      selector: (row) => row.siteName,
      sortable: true,
      cell: (row) => row.siteName,
    },
    {
      name: <div>PROJECT NAME</div>,
      selector: (row) => row.projectName,
      sortable: true,
      cell: (row) => row.projectName,
      width: '200px',
    },
    {
      name: <div>DATE</div>,
      selector: (row) => row.date,
      sortable: true,
      cell: (row) => row.date,
      width: '110px',
    },
    {
      name: <div>SHIFT START TIME</div>,
      selector: (row) => row.shiftStartTime,
      sortable: false,
      cell: (row) => row.shiftStartTime,
      width: '110px',
    },
    {
      name: <div>CHECKIN TIME</div>,
      selector: (row) => row.checkinTime,
      sortable: false,
      cell: (row) => row.checkinTime,
      width: '110px',
    },
    {
      name: <div>CHECKIN ADHERENCE</div>,
      selector: (row) => row.checkinAdherence,
      sortable: false,
      cell: (row) => row.checkinAdherence,
    },
    {
      name: <div>SHIFT END TIME</div>,
      selector: (row) => row.shiftEndTime,
      sortable: false,
      cell: (row) => row.shiftEndTime,
      width: '110px',
    },
    {
      name: <div>CHECKOUT TIME</div>,
      selector: (row) => row.checkoutTime,
      sortable: false,
      cell: (row) => row.checkoutTime,
      width: '110px',
    },
    {
      name: <div>CHECKOUT ADHERENCE</div>,
      selector: (row) => row.checkoutAdherence,
      sortable: false,
      cell: (row) => row.checkoutAdherence,
    },
    {
      name: <div>SHIFT TIME</div>,
      selector: (row) => row.shiftTime,
      sortable: false,
      cell: (row) => row.shiftTime,
      width: '110px',
    },
    {
      name: <div>TOTAL LOGGED TIME</div>,
      selector: (row) => row.totalWorkingTime,
      sortable: false,
      cell: (row) => row.totalWorkingTime,
      width: '110px',
    },
    {
      name: <div>SCHEDULE ADHERENCE</div>,
      selector: (row) => row.shiftAdherence,
      sortable: false,
      cell: (row) => row.shiftAdherence,
    },
    permissions &&
      (permissions.includes('tardy_request') ||
        permissions.includes('tardy_approval')) && {
        name: <div>TARDY</div>,
        selector: (row) => row.tardy,
        sortable: false,
        cell: (row) => row.tardy,
        width: '170px',
      },
  ];

  return (
    <Card.Body className="p-0">
      <div>
        <DataTable
          columns={tableColumns}
          data={projectsData}
          noDataComponent={
            isLoading ? (
              ''
            ) : (
              <p className="text-center pt-3">{NO_DATA.NO_ADHERENCE}</p>
            )
          }
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={[10, 20, 30]}
          paginationComponentOptions={{
            rowsPerPageText: 'Show Results',
            rangeSeparatorText: 'out of',
          }}
          onChangeRowsPerPage={handleLimitChange}
          onChangePage={handlePageChange}
        />
      </div>
    </Card.Body>
  );
};

AdherenceDataTable.propTypes = {
  isLoading: PropTypes.bool,
  projectsData: PropTypes.array,
  totalRows: PropTypes.number,
  perPage: PropTypes.number,
  handlePageChange: PropTypes.func,
  handleLimitChange: PropTypes.func,
};

export default memo(AdherenceDataTable);
